import { Component } from '@angular/core';

@Component({
  selector: 'app-create-projetos',
  templateUrl: './create-projetos.component.html',
  styleUrls: ['./create-projetos.component.scss']
})
export class CreateProjetosComponent {

}
